<template>
  <div class="animated fadeIn">
    <div class="mt-5 display-4 text-left">
      <span>Add Contact</span>
    </div>
    <div v-if="customer_contact">
      <b-card class="mt-3">
        <customer-contact-form-group
          :customer_contact="customer_contact"
          :disable_email="false"
          @onCustomerContactChange="onCustomerContactChange"
        ></customer-contact-form-group>
      </b-card>
      <div class="clearfix mb-5">
        <b-button variant="success" class="float-right" @click="saveContact">Save</b-button>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomerContactFormGroup from "../../components/auth/register/inner/CustomerContactFormGroup";
  import CustomerContactModel from "../../models/crm/CustomerContactModel";

  export default {
    components: {CustomerContactFormGroup},
    name: 'ContactAdd',
    data() {
      return {
        authenticated_customer_id: (this.$store.getters.getAuthCustomerID || null),
        customer_contact: (new CustomerContactModel())
      }
    },
    methods: {

      onCustomerContactChange: function(customer_contact) {
        this.customer_contact.set(customer_contact);
      },

      saveContact: function() {
        this.customer_contact.set('customer_id', this.authenticated_customer_id);
        this.customer_contact.save().then(() => {
          this.$bvToast.toast('Thanks!', {
            title: 'Contact created successfully',
            variant: 'success',
            autoHideDelay: 1000
          });
          setTimeout(() => { this.$router.push('/team') }, 1000)
        });
      },

    },
    mounted() {}
  }
</script>
